import { useMutation, useQueryClient } from "@tanstack/react-query";
import { tournamentApi } from "@bw/shared/api";
import { queryKeys } from "../../../common/query/queryClient";

export function useRegistrationCardSetup(
  tournamentId: string,
  checkoutId: string,
) {
  const client = useQueryClient();
  const reconcile = () =>
    Promise.all([
      client.invalidateQueries({
        queryKey: queryKeys.tournaments.myRegistrationPayments(),
      }),
      client.invalidateQueries({
        queryKey: queryKeys.tournaments.myRegistrations(),
      }),
      client.invalidateQueries({
        queryKey: queryKeys.tournaments.registrationsMine(tournamentId),
      }),
      client.invalidateQueries({
        queryKey: queryKeys.tournaments.eligibility(tournamentId),
      }),
      client.invalidateQueries({
        queryKey: queryKeys.tournaments.events(tournamentId),
      }),
    ]);
  const resume = useMutation({
    mutationFn: (cardId: string) =>
      tournamentApi.resumeRegistrationCardSetup(checkoutId, cardId),
    onSettled: reconcile,
  });
  const release = useMutation({
    mutationFn: () => tournamentApi.releaseRegistrationCardSetup(checkoutId),
    onSettled: reconcile,
  });
  return { resume, release };
}
